"use strict";
angular.module("internal.exams").controller("InternalExamPackets", [
    "$scope",
    "EXPackets",
    "LicenseCategoryLevels",
    "Permissions",
    function ($scope, EXPackets, LicenseCategoryLevels, Permissions) {
        $scope.levels = [];
        $scope.bulkActionItems = [];

        $scope.getPackets = function () {
            EXPackets.get().then(function (Packets) {
                $scope.Packets = Packets.records;
                $scope.Packets.forEach(function (packet) {
                    packet.title = packet.description;
                });
                $scope.loading = false;
            });
            LicenseCategoryLevels.get({ entity_id: '5384A3C9-A244-41CC-92C1-6423E4561B83' }).then(function (licenseCategoryLevels) {
                licenseCategoryLevels.forEach(function (licenseCategoryLevel) {
                    $scope.levels.push({
                        name: licenseCategoryLevel.combined_name,
                        id: licenseCategoryLevel.id
                    });
                })
            });
        }

        Permissions.edit('internal.exams.administrative.packets').then(function (access) {
            $scope.bulkActionAccess = access;
        });

        $scope.setStatus = function (bulkApply, status) {
            $scope.bulkActionRunning = true;
            bulkApply.isOpen = false;
            if (status != null && $scope.bulkActionItems.length > 0) {
                EXPackets.updateStatuses($scope.bulkActionItems, status).then(function () {
                    $scope.bulkActionItems = [];
                    $scope.getPackets();
                    $scope.bulkActionRunning = false;
                });
            }
        };


        $scope.columns = [
            {
                label: "Name",
                field: "name",
                link: {
                    state: "internal.exams.administrative.packet",
                    params: [
                        {
                            name: "id",
                            field: "id"
                        }
                    ]
                }
            },
            {
                label: "Level",
                field: "licenseCategoryLevelName"
            },
            {
                label: "Active",
                field: "activeStatus",
                type: "yesno"
            },
            {
                label: "Total Failed Attempts",
                field: "maxFailedAttempts"
            },
            {
                label: "Forms",
                field: "numOfForms"
            },
            {
                label: "Last Modified",
                field: "modifiedOnUtc",
                type: "datetime"
            },
        ];
        $scope.filters = [
            {
                name: "Active",
                field: "activeStatus",
                options: [
                    { name: "Not Active", id: false },
                    { name: "Active", id: true }
                ]
            },
            {
                name: "Level",
                field: "licenseCategoryLevelId",
                options: $scope.levels
            }
        ];
        $scope.getPackets();
    }
]);